<template>
	<div class="BookCatalog">
		<!-- 目录显示 -->
		<template v-if="catalogList.length">
			<!-- pc目录 -->
			<ul v-if="catalayout">
				<li v-for="(item,index) in catalogList" :key="index">
					<!-- 只有节or章 -->
					<div v-if="item.children == null || item.subChapterCount == 0">
						<div :class="item.pageCount > 0 ? 'nodeWrap canHover' : 'nodeWrap'">
							<span class="nolyshow pc_nodeText" :id="'title'+item.id" v-if="item.pageCount === 0" :title="item.title">{{item.title}}</span>
							<span class="pc_nodeText" :id="'title'+item.id" v-else-if="item.currentPrice === -1 && item.tryReadingPages > 0" :title="item.title" @click="OpenTitleRead(item.id,item.purchased,1)">{{item.title}}</span>
							<span class="pc_nodeText" :id="'title'+item.id" v-else-if="item.currentPrice != -1 && item.tryReadingPages > 0" @click="OpenTitleRead(item.id,item.purchased)" :title="item.title">{{item.title}}</span>
							<span class="pc_nodeText" :id="'title'+item.id" v-else :title="item.title">{{item.title}}</span>
							<div v-if="item.currentPrice >= 0">
								<div class="PurchasedBtn" v-if="item.purchased && item.isGoods">
									<div class="chapterPrice" v-if="item.subChapterCount > 1">
										<span>{{'¥'+item.currentPrice}}</span>
										<span class="original" v-if="item.currentPrice != item.originalPrice">{{'¥'+item.originalPrice}}</span>
										<span v-else></span>
									</div>
									<span>已购</span>
									<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:item.id}}" target="_blank" class="hoverBtn" v-if="item.pageCount > 0">去阅读</router-link>
								</div>
								<div class="tryReadBtn" v-else>
									<div class="chapterPrice">
										<span>{{'¥'+item.currentPrice}}</span>
										<span class="original" v-if="item.currentPrice != item.originalPrice">{{'¥'+item.originalPrice}}</span>
										<span v-else></span>
									</div>
									<span class="tryText" v-if="item.tryReadingPages > 0" @click="OpenTryRead(item.id)">试读</span>
									<span class="tryText" style="border: 0;" v-else></span>
									<!-- 加入购物车 -->
									<span class="Addbooklist" @click="OpenChapterBuy('cart',item.id)">加入书单</span>
									<!-- 直接购买 -->
									<!-- <span style="display: none;" class="Addbooklist" @click="OpenChapterBuy('zj',item.id)">加入书单</span> -->
								</div>
							</div>
							<div v-else-if="item.currentPrice === -1">
								<div class="PurchasedBtn" v-if="item.purchased && item.isGoods">
									<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:item.id}}" target="_blank" class="hoverBtn" v-if="item.pageCount > 0">去阅读</router-link>
								</div>
								<div class="tryReadBtn" v-else>
									<span class="tryText" v-if="item.tryReadingPages > 0" @click="OpenTryRead(item.id,1)">试读</span>
									<span class="tryText" style="border: 0;" v-else></span>
									<span style="width: 88px;display: inline-block;"> </span>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<!-- 章 -->
						<div class="chapterWrap">
							<span :id="'title'+item.id">{{item.title}}</span>
							<div>
								<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:item.children[0].id}}" target="_blank" v-if="item.purchased && item.isGoods" class="pc_allChapter allRead">整章阅读</router-link>
								<!-- 加入购物车 -->
								<span v-else @click="OpenChapterBuy('cart',item.id,item.children[0].id)" class="pc_allChapter">整章购买</span>
								<!-- 直接购买 -->
								<!-- <span style="display: none;" @click="OpenChapterBuy('zj',item.id,item.children[0].id)" class="pc_allChapter">整章购买</span> -->
								<div class="chapterPrice" v-if="item.currentPrice != -1">
									<span>{{'¥'+item.currentPrice}}</span>
									<span class="original" v-if="item.currentPrice != item.originalPrice">{{'¥'+item.originalPrice}}</span>
									<span v-else></span>
								</div>
							</div>
						</div>
						<!-- 节 -->
						<div v-for="(it,ind) in item.children" :key="ind" :class="it.pageCount > 0?'nodeWrap canHover':'nodeWrap'">
							<span :id="'title'+it.id" class="nolyshow pc_nodeText" v-if="it.pageCount === 0" :title="it.title">{{it.title}}</span>
							<span :id="'title'+it.id" class="pc_nodeText" v-else-if="it.currentPrice === -1 && it.tryReadingPages > 0" :title="it.title" @click="OpenTitleRead(it.id,it.purchased,1)">{{it.title}}</span>
							<span :id="'title'+it.id" class="pc_nodeText" v-else-if="it.currentPrice != -1 && it.tryReadingPages > 0" @click="OpenTitleRead(it.id,it.purchased)" :title="it.title">{{it.title}}</span>
							<span :id="'title'+it.id" class="pc_nodeText" v-else :title="it.title">{{it.title}}</span>
							<div v-if="it.currentPrice >= 0">
								<div class="PurchasedBtn" v-if="it.purchased && it.isGoods">
									<div class="chapterPrice" v-if="item.subChapterCount > 1">
										<span>{{'¥'+it.currentPrice}}</span>
										<span class="original" v-if="it.currentPrice != it.originalPrice">{{'¥'+it.originalPrice}}</span>
										<span v-else></span>
									</div>
									<span>已购</span>
									<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:it.id}}" target="_blank" class="hoverBtn" v-if="it.pageCount > 0">去阅读</router-link>
									<a class="hoverBtn" style="width: 88px;" v-else></a>
								</div>
								<div class="tryReadBtn" v-else>
									<div class="chapterPrice" v-if="item.subChapterCount > 1">
										<span>{{'¥'+it.currentPrice}}</span>
										<span class="original" v-if="it.currentPrice != it.originalPrice">{{'¥'+it.originalPrice}}</span>
										<span v-else></span>
									</div>
									<span class="tryText" v-if="it.tryReadingPages > 0 && item.subChapterCount > 1" @click="OpenTryRead(it.id)">试读</span>
									<span class="tryText" v-else-if="it.tryReadingPages > 0 && item.subChapterCount === 1" @click="OpenTryRead(it.id,0,index)">试读</span>
									<span class="tryText" style="border: 0;" v-else></span>
									<!-- 加入购物车 -->
									<span class="Addbooklist" v-if="item.subChapterCount > 1" @click="OpenChapterBuy('cart',it.id)">加入书单</span>
									<span style="width: 88px;display: inline-block;" v-else></span>
									<!-- 直接购买 -->
									<!-- <span style="display: none;" class="Addbooklist" @click="OpenChapterBuy('zj',it.id)">加入书单</span> -->
								</div>
							</div>
							<div v-else-if="it.currentPrice === -1">
								<div class="PurchasedBtn" v-if="it.purchased && it.isGoods">
									<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:it.id}}" target="_blank" class="hoverBtn" v-if="it.pageCount > 0">去阅读</router-link>
								</div>
								<div class="tryReadBtn" v-else>
									<span class="tryText" v-if="it.tryReadingPages > 0" @click="OpenTryRead(it.id,0,index)">试读</span>
									<span class="tryText" style="border: 0;" v-else></span>
									<span style="width: 88px;display: inline-block;"></span>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
			<!-- mobile目录 -->
			<ul v-else>
				<li v-for="(item,index) in catalogList" :key="index">
					<!-- 只有节or章 -->
					<div v-if="item.children == null || item.subChapterCount == 0">
						<div class="nodeWrap">
							<div class="TitlePrice">
								<span :class="item.pageCount>0?'mobile_nodeText':'nolyshow mobile_nodeText'" @click="GoTryRead(item.pageCount,item.purchased,item.id,item.tryReadingPages,item.currentPrice,1)">{{item.title}}</span>
								<div class="chapterPrice" v-if="item.currentPrice != -1">
									<span>{{'¥'+item.currentPrice}}</span>
									<span class="original" v-if="item.currentPrice != item.originalPrice">{{'¥'+item.originalPrice}}</span>
									<span v-else></span>
								</div>
							</div>
							<div class="btnWrap_mob">
								<div><a href="javascript:;" @click="GoTryRead(item.pageCount,item.purchased,item.id,item.tryReadingPages,item.currentPrice,1)" class="mobile_tryread" v-if="item.tryReadingPages > 0 && !item.purchased"></a></div>
								<div class="btnBox_mob">
									<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:item.id}}" class="mobileAllRead" v-if="item.purchased && item.isGoods && item.pageCount > 0"></router-link>
									<!-- 加入购物车 -->
									<a href="javascript:;" @click="GoPayment('cart',0,item.id)" class="mobile_addBooklist" v-if="item.currentPrice != -1 && !item.purchased"></a>
									<!-- 直接购买 -->
									<!-- <a href="javascript:;" style="display: none;" @click="GoPayment('zj',0,item.id)" class="mobile_addBooklist"></a> -->
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<!-- 章 -->
						<div class="chapterWrap">
							<span>{{item.title}}</span>
							<div v-if="item.isGoods">
								<div class="chapterPrice" v-if="item.currentPrice != -1">
									<span>{{'¥'+item.currentPrice}}</span>
									<span class="original" v-if="item.currentPrice != item.originalPrice">{{'¥'+item.originalPrice}}</span>
									<span v-else></span>
								</div>
								<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:item.children[0].id}}" class="mobileAllRead allRead" v-if="item.purchased"></router-link>
								<!-- 加入购物车 -->
								<a href="javascript:;" @click="GoPayment('cart',0,item.id,item.children[0].id)" class="mobile_allChapter" v-if="item.currentPrice != -1 && !item.purchased"></a>
								<!-- 直接购买 -->
								<!-- <a href="javascript:;" style="display: none;" @click="GoPayment('zj',0,item.id,item.children[0].id)" class="mobile_allChapter"></a> -->
							</div>
						</div>
						<!-- 节 -->
						<div class="nodeWrap" v-for="(it,ind) in item.children" :key="ind">
							<div class="TitlePrice">
								<span :class="it.pageCount>0?'mobile_nodeText':'nolyshow mobile_nodeText'" @click="GoTryRead(it.pageCount,it.purchased,it.id,it.tryReadingPages,it.currentPrice,0,index)">{{it.title}}</span>
								<div class="chapterPrice" v-if="it.currentPrice != -1 && item.subChapterCount > 1">
									<span>{{'¥'+it.currentPrice}}</span>
									<span class="original" v-if="it.currentPrice != it.originalPrice">{{'¥'+it.originalPrice}}</span>
									<span v-else></span>
								</div>
							</div>
							<div class="btnWrap_mob">
								<div><a href="javascript:;" @click="GoTryRead(it.pageCount,it.purchased,it.id,it.tryReadingPages,it.currentPrice,0,index)" class="mobile_tryread" v-if="it.tryReadingPages > 0 && !it.purchased"></a></div>
								<div class="btnBox_mob">
									<router-link :to="{path:'/bookRead', query:{InformationId:InformationId,id:it.id}}" class="mobileAllRead" v-if="it.purchased && it.isGoods && it.pageCount > 0"></router-link>
									<!-- 加入购物车 -->
									<a href="javascript:;" @click="GoPayment('cart',0,it.id)" class="mobile_addBooklist" v-if="it.currentPrice != -1 && !it.purchased && item.subChapterCount > 1"></a>
									<!-- 直接购买 -->
									<!-- <a href="javascript:;" style="display: none;" @click="GoPayment('zj',0,it.id)" class="mobile_addBooklist"></a> -->
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</template>
		
		<!-- 介绍 -->
		<template v-else>
			<div class="introduce-cont" v-html="introduce"></div>
		</template>
		
		<!-- 试读 -->
		<div v-if="showTryRead">
			<TryRead :fatherId="fatherid" :tryReadId="tryReadId" :firstChildId="firstchildId" :InformationId="InformationId" :sellWay="sellway" />
		</div>
		<!-- 付款弹窗 -->
		<div class="PopupWrap" v-if="showChapterBuy">
			<DownloadChapter :downloadWay="downloadWay" :chapterId="chapterId" :goods="Goods" :sellWayText="textTip" />
		</div>
	</div>
</template>

<script>
	import common from '../../assets/js/common.js'
	import DownloadChapter from '../../components/DownloadChapter.vue'
	import TryRead from '../../components/TryRead.vue'
	export default {
		data() {
			return {
				catalogList: [], // 目录列表
				showTryRead: false, // 试读
				showChapterBuy: false, // 章节下载
				downloadWay: 0, // 下载方式 0：章节下载 1：全书购买
				InformationId: undefined, // 情报id
				CurrentPage: 1, // 当前页
				tryReadId: undefined, // 试读id
				tryTitle: '', // 试读标题
				tryReadPage: 1, // 试读页数
				Goods: {}, // 商品
				chapterId: undefined, // 章节id
				catalogArr: [], // 目录--不分章节
				catalayout: true, // 布局
				isSell: 0, // 是否是商品
				fatherid: undefined, // 试读的章id
				firstchildId: undefined, // 章的第一个节id
				textTip: undefined, // 试读里售卖方式
				sellway: undefined,  // 售卖方式
				introduce: '' // 介绍
			}
		},
		mounted() {
			// 获取情报id
			this.InformationId = this.$route.query.InformationId - 0;
			// 判断加载哪个dom
			let wid = window.innerWidth;
			if (wid >= 320 && wid <= 1024) {
				this.catalayout = false;
				// 获取目录
				this.GetCatalog(false);
			} else {
				this.ShowPopupFn();
				// 从搜索里点进来 定位
				let aid = this.$route.query.InformationContentId;
				// 获取目录
				this.GetCatalog(true, aid);
			}
			// 触发关闭章节购买事件车
			common.$on('closeChapter', () => {
				this.showChapterBuy = false;
			});
			// 关闭试读
			common.$on('closeRead', () => {
				this.showTryRead = false;
				if (this.$route.query.isPopup) {
					this.$router.push({
						path: '/bookDetail/bookCatalog',
						query: {
							InformationId: this.InformationId
						}
					});
				}
			});
			// 购买方式
			this.BuyBookWay();
		},
		methods: {
			// 是否出现弹窗
			ShowPopupFn() {
				let isshow = this.$route.query.isPopup;
				if (isshow != 'true') return;

				this.tryReadId = this.$route.query.tryReadId - 0;
				this.sellway = this.$route.query.sellWay;
				if (this.sellway == 0) {
					this.fatherid = this.$route.query.fatherId - 0;
					this.firstchildId = this.$route.query.firstChildId - 0;
				}
				this.$fetch('/api/information/' + this.InformationId + '/informationContent/' + this.tryReadId)
					.then((res) => {
						if (res.data.purchased) {
							this.$confirm('您刚才选择试读的是已购内容，可直接去阅读。', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push({
									path: '/bookRead',
									query: {
										InformationId: this.InformationId,
										id: this.tryReadId
									}
								});
							}).catch(() => {});
							return;
						}
						this.showTryRead = true;
					}).catch((err) => {
						throw err;
					});
			},
			// 获取目录
			GetCatalog(type, aid) {
				let params = '?PageNumber=' + this.CurrentPage + '&PageSize=500&OrderByDictionary[NodeType]=asc&OrderByDictionary[ParentId]=asc&OrderByDictionary[Id]=asc';
				this.$fetch('/api/information/' + this.InformationId + '/informationContent' + params)
					.then((res) => {
						if(res.data.length === 0) {
							common.$emit('catalogEvent', false);
							this.GetBookIntr();
							return;
						}
						
						common.$emit('catalogEvent', true);
						// 获取章or节的第一个id
						if (res.data[0].children == null) {
							sessionStorage.setItem('firstPurchasedId', res.data[0].id);
						} else {
							sessionStorage.setItem('firstPurchasedId', res.data[0].children[0].id);
						}
						// 目录
						this.catalogList = res.data;
						// type true代表需跳转对应章节 aid章节id
						if(type && aid && this.catalogList.length) {
							this.toChapterFn(aid)
						}
					}).catch((err) => {
						throw err;
					});
			},
			// 获取书本介绍
			GetBookIntr() {
			  this.$fetch("/api/information/" + this.InformationId).then(res => {
					this.introduce = res.data.introduce;
				}).catch(err => {
					throw err;
				});
			},
			// 跳转对应到章节
			toChapterFn(aid) {
				this.$nextTick(() => {
					let div = document.getElementById('title' + aid);
					if (div) {
						div.style.color = '#E02020';
						document.body.scrollTop = div.offsetTop - 200;
					}
				})
				// setTimeout(() => {
				// 	let div = document.getElementById('title' + aid);
				// 	console.log(div)
				// 	if (div) {
				// 		div.style.color = '#E02020';
				// 		document.body.scrollTop = div.offsetTop - 200;
				// 	}
				// }, 500);
				// let timeout = null;
				// let count = 0;
				// timeout = setInterval(()=> {
				// 	count++
				// 	console.log(count)
				// 	let div = document.getElementById('title' + aid);
				// 	console.log(div)
				// 	if (div) {
				// 		div.style.color = '#E02020';
				// 		document.body.scrollTop = div.offsetTop - 200;
				// 		clearInterval(timeout)
				// 		timeout = null
				// 	}
				// 	if(count === 10) {
				// 		console.log('over')
				// 		clearInterval(timeout)
				// 		timeout = null
				// 	}
				// }, 200);
			},
			// 去试读-mobile
			GoTryRead(pagecount, ispurchased, id, tryReadPage, issell, type, index) {
				if (pagecount === 0) return;
				if (ispurchased) {
					this.$router.push({
						path: '/bookRead',
						query: {
							id: id,
							InformationId: this.InformationId
						}
					});
					return;
				}
				if (tryReadPage === 0) return;
				if (type == 1) {
					this.$router.push({
						path: '/bookTryRead',
						query: {
							id: id,
							InformationId: this.InformationId,
							sellway: type
						}
					});
					return;
				}
				let arr = this.catalogList[index];
				this.$router.push({
					path: '/bookTryRead',
					query: {
						id: id,
						fatherId: arr.id,
						firstchildId: arr.children[0].id,
						InformationId: this.InformationId,
						sellway: type
					}
				});
			},
			// 点击标题 进入阅读or试读
			OpenTitleRead(id, purchased, type) {
				if (purchased) {
					this.$router.push({
						path: '/bookRead',
						query: {
							InformationId: this.InformationId,
							id: id
						}
					});
				} else {
					this.OpenTryRead(id, type);
				}
			},
			// 打开试读-pc  价格为-1时，需要把章id以及章的第一节id传过去
			OpenTryRead(id, type, index) {
				this.showTryRead = true;
				this.tryReadId = id;
				this.sellway = type;
				if (type == 0) {
					let arr = this.catalogList[index];
					this.fatherid = arr.id;
					this.firstchildId = arr.children[0].id;
				}
			},
			// 判断是否登录
			LoginTipFn() {
				this.$confirm('此操作需登录后进行，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let nowHref = location.href;
					let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(
						nowHref);
					location.href = href;
				}).catch(() => {});
			},
			// 去支付--mobile childrenId:为整章购买的第一节id
			GoPayment(isCart, type, id, childrenId) {
				this.$fetch('/Login')
					.then((res) => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}
						
						// 加入购物车
						if(isCart === 'cart') {
							this.GetSingleGoods('cart', id, childrenId)
							return
						}
						
						// *直接购买方式（暂时弃用）
						this.$router.push({
							name: "BookPayment",
							query: {
								type: type,
								InformationId: this.InformationId,
								id: id,
								chapterId: childrenId ? childrenId : id
							}
						});
					}).catch((err) => {
						throw err;
					});
			},
			// 支付方式
			BuyBookWay() {
				common.$on('buyBook', (isCart, type, issell, chapterId, firstchildId) => {
					// *直接购买方式isCart: zj
					this.textTip = issell;
					
					// 加入购物车方式isCart: cart
					if(issell === -1) {
						this.$confirm('您选择试读的文章无法单独加入书单，所以将选择其所在章（书）加入，是否继续？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							if (type == 0) {
								this.GetSingleGoods(isCart, chapterId, firstchildId);
							} else if (type == 1) {
								this.GetGoods(isCart);
							}
						}).catch(() => {});
					}else {
						if (type == 0) {
							this.GetSingleGoods(isCart, chapterId, firstchildId);
						} else if (type == 1) {
							this.GetGoods(isCart);
						}
					}
				});
			},
			// 打开章节购买-获取情报里的内容商品  chapterId:为整章购买的第一节id isgoods:是否是商品 isCart: 值为cart加入购物车方式
			OpenChapterBuy(isCart, id, chapterId) {
				this.$fetch('/Login')
					.then((res) => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}
						
						this.GetSingleGoods(isCart, id, chapterId);
					}).catch((err) => {
						throw err;
					});
			},
			// 获取单个商品
			GetSingleGoods(isCart, id, chapterId) {
				this.downloadWay = 0;
				this.chapterId = chapterId ? chapterId : id;
				this.$fetch('/api/information/' + this.InformationId + '/informationContent/goods/?id=' + id)
					.then((res) => {
						if(isCart === 'cart') {
							// 加入购物车
							this.addToCartFn(res.data)
							return
						}
						
						// *直接购买方式-打开购买弹窗（暂时弃用）
						this.Goods = res.data;
						this.showChapterBuy = true;
					}).catch((err) => {
						throw err;
					});
			},
			// 加入购物车
			addToCartFn(goods) {
				this.$post('/api/ShoppingCarts', {'goodsId': goods.id}).then(res => {
					// 获取购物车数量
					this.getCartCountFn();
					// 提示
					common.$emit('openTip', goods)
				}).catch(err => {
					this.$message({
						message: err.response.data,
						type: 'error',
						offset: 100
					});
				})
			},
			// 获取购物车数量
			getCartCountFn() {
				common.$emit('getCartNum')
			},
			// 获取整个情报商品
			GetGoods(isCart) {
				this.$fetch('/Login')
					.then((res) => {
						// 判断登陆状态
						if (res.data.accessAllowed === false) {
							this.LoginTipFn();
							return;
						}

						this.downloadWay = 1;
						this.chapterId = sessionStorage.getItem('firstPurchasedId');
						this.$fetch('/api/information/goods/?id=' + this.InformationId)
							.then((res) => {
								if(isCart === 'cart') {
									// 加入购物车
									this.addToCartFn(res.data)
									return
								}
								
								// *直接购买方式-打开购买弹窗（暂时弃用）
								this.Goods = res.data;
								this.showChapterBuy = true;
							}).catch((err) => {
								throw err;
							});
					}).catch((err) => {
						throw err;
					});
			}
		},
		components: {
			DownloadChapter,
			TryRead
		}
	}
</script>

<style scoped>
	@import './BookCatalog.css';
</style>



// WEBPACK FOOTER //
// src/pages/BookDetails/BookCatalog.vue